import { useGetChannelsApiV1Suspense } from "@/api/__generated__/api.schema";
import { useWorkspaceId } from "@/hooks/auth/use-workspace";
import { useCallback, useEffect } from "react";
import { useSearchParams } from "react-router";

export function useChannelAnalytics() {
  const workspaceId = useWorkspaceId();
  const {
    data: {
      data: { items: channels },
    },
  } = useGetChannelsApiV1Suspense(workspaceId);
  const [searchParams, setSearchParamsBase] = useSearchParams();

  const channelId = searchParams.get("channelId");
  const initialChannelId = channels[0]?.id;

  const setChannelId = useCallback(
    (newChannelId: string | null) => {
      setSearchParamsBase((prevParams) => {
        const newSearchParams = new URLSearchParams(prevParams);
        if (newChannelId != null) {
          newSearchParams.set("channelId", newChannelId);
        } else {
          newSearchParams.delete("channelId");
        }
        return newSearchParams;
      });
    },
    [setSearchParamsBase],
  );

  useEffect(() => {
    if (channelId == null || !channels.find((channel) => channel.id === channelId)) {
      setChannelId(initialChannelId);
    }
  }, [channelId, initialChannelId, setChannelId, channels]);

  return { channelId: channelId ?? initialChannelId, setChannelId, channels };
}
